import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DocumentService from '@/shared/services/DocumentService';
import moment from 'moment';

const documentTypes = [
  17, //UBO register pdf
];
const mapSnapshotLine = ({ errors, ...line }) => {
  var result = { ...line };
  if (errors && typeof errors === 'string') result.errors = JSON.parse(errors);
  return result;
};

const mapSnapshot = ({ lines = [], ...snapshot }) => ({
  ...snapshot,
  lines: lines.map(mapSnapshotLine),
});

angular.module('cxRelations').directive('cxRelUbo', [
  function() {
    return {
      restrict: 'E',
      template: require('./relUbo.html'),
      bindToController: {
        snapshotOverview: '=data',
        field: '=',
        relation: '=',
        saveRemote: '&save',
        disabled: '=?',
      },
      controllerAs: 'vm',
      controller: [
        '$scope',
        '$q',
        'ModalService',
        'flySvc',
        'appUrls',
        '$http',
        'checkSecurity',
        'dialogsSvc',
        '$timeout',
        function(
          $scope,
          $q,
          ModalService,
          flySvc,
          appUrls,
          $http,
          checkSecurity,
          dialogsSvc,
          $timeout,
        ) {
          var vm = this;

          vm.$onInit = function() {
            vm.snapshot = null;
            vm.highlightRelation = null;
            vm.documents = [];
            vm.showRelativePercentages = false;

            vm.loadDocuments();
            $scope.$watch('vm.snapshotOverview', vm.initializeOverview);
          };

          vm.getDocumentInfo = function() {
            vm.documentInfo = null;
            if (!checkSecurity('Documents:r')) return;
            if (vm.snapshot && vm.snapshot.documentId) {
              $http.get(appUrls.documents + '/api/documents/info/' + vm.snapshot.documentId).then(
                function({ data }) {
                  vm.documentInfo = data;
                },
                function(error) {},
              );
            }
          };
          vm.loadDocuments = function() {
            if (!checkSecurity('Documents:r')) return;
            $http
              .get(`${appUrls.documents}/api/Documents/Links/${vm.relation.id}/3`, {
                params: { documentTypes },
              })
              .then(function(result) {
                vm.documents = result.data || [];
              });
          };
          vm.setShowRelativePercentages = function() {
            vm.showRelativePercentages = !!(
              vm.snapshot &&
              vm.snapshot.lines &&
              vm.snapshot.lines.some(x => x.relativeSharesPercentage || x.relativeVotesPercentage)
            );
          };

          vm.initializeOverview = function() {
            vm.snapshotDates = [];
            vm.snapshot = null;
            vm.documentInfo = null;

            if (
              vm.snapshotOverview &&
              vm.snapshotOverview.snapshots &&
              vm.snapshotOverview.snapshots.length > 0
            ) {
              vm.snapshotDates = vm.snapshotOverview.snapshots;
            }
            if (vm.snapshotOverview && vm.snapshotOverview.latestSnapshot) {
              vm.snapshot = mapSnapshot(vm.snapshotOverview.latestSnapshot);
              vm.setShowRelativePercentages();

              vm.currentSnapshotDate = vm.snapshotDates.find(x => x.id === vm.snapshot.id);
              if (!vm.currentSnapshotDate && vm.snapshotDates.length) {
                vm.currentSnapshotDate = vm.snapshotDates[0];
              }
            }

            vm.getDocumentInfo();
          };

          vm.setResponsibilityType = function(value) {
            const relationId = $scope.relation.id;

            return $http
              .get(
                appUrls.api +
                  '/api/ubo/SetResponsibilityType?id=' +
                  relationId +
                  '&responsibilityType=' +
                  value,
              )
              .then(
                function({ data }) {
                  vm.snapshotOverview = data;
                  flySvc.success('SuccessTitle');
                },
                function(error) {
                  flySvc.error(error);
                },
              );
          };
          vm.setOnlineSinceDate = function(value) {
            const relationId = $scope.relation.id;

            return $http
              .put(`${appUrls.api}/api/ubo/UpdateOnlineSinceDate/${relationId}`, null, {
                params: { date: value ? value.ISO() : '' },
              })
              .then(
                function({ data }) {
                  vm.snapshotOverview = data;
                  flySvc.success('SuccessTitle');
                },
                function(error) {
                  flySvc.error(error);
                },
              );
          };
          vm.updateSnapshot = function(data) {
            vm.snapshot = mapSnapshot(data);
            if (
              vm.snapshotOverview.latestSnapshot &&
              vm.snapshotOverview.latestSnapshot.id === vm.snapshot.id
            ) {
              vm.snapshotOverview.latestSnapshot = vm.snapshot;
            }
            vm.setShowRelativePercentages();
          };

          vm.executeVerification = function() {
            const relationId = $scope.relation.id;
            vm.creatingSnapshot = true;

            $http.post(appUrls.api + '/api/ubo/CreateSnapshot/' + relationId).then(
              function({ data }) {
                var snapshot = mapSnapshot(data);
                vm.snapshotOverview.selfResponsibleForUbo = false;
                vm.snapshotDates.unshift(snapshot);
                vm.snapshot = snapshot;
                vm.currentSnapshotDate = snapshot;
                vm.snapshotOverview.latestSnapshot = snapshot;
                vm.creatingSnapshot = false;
                vm.documentInfo = null;

                vm.setShowRelativePercentages();
                flySvc.success();
              },
              function(error) {
                vm.creatingSnapshot = false;

                flySvc.error(error);
              },
            );
          };

          vm.update = function(field, value) {
            var model = angular.copy(vm.snapshot);

            if (angular.equals(model[field], value)) return true;

            model[field] = value;

            if (model.onlineSinceDate instanceof Date)
              model.onlineSinceDate = moment.utc(model.onlineSinceDate);

            return $http.put(appUrls.api + '/api/ubo/updatesnapshot/', model).then(
              function({ data }) {
                vm.updateSnapshot(data);

                flySvc.success('SuccessTitle');
              },
              function(error) {
                flySvc.error(error);
              },
            );
          };

          vm.removeDocument = function() {
            const oldDocumentId = vm.snapshot.documentId;
            if (!oldDocumentId) return;
            return $http.delete(appUrls.api + '/api/ubo/DeleteUboDocument/' + vm.snapshot.id).then(
              function({ data }) {
                vm.updateSnapshot(data);
                vm.documentInfo = null;
                vm.documents = vm.documents.filter(x => x.id !== oldDocumentId);
                flySvc.success('SuccessTitle');
              },
              function(error) {
                flySvc.error(error);
              },
            );
          };

          vm.markSnapshotEnteredOnline = function() {
            var id = vm.currentSnapshotDate.id;

            $http.put(appUrls.api + '/api/ubo/MarkSnapshotEnteredOnline/' + id).then(
              function({ data }) {
                vm.updateSnapshot(data);
                flySvc.success('msgConfirmChange');
              },
              function(error) {
                flySvc.error(error);
              },
            );
          };

          vm.markSnapshotRevisionOk = function() {
            var id = vm.currentSnapshotDate.id;

            vm.markingRevisionOk = true;

            $http.put(appUrls.api + '/api/ubo/MarkSnapshotRevisionOk/' + id).then(
              function({ data }) {
                vm.markingRevisionOk = false;

                vm.updateSnapshot(data);

                flySvc.success('msgConfirmChange');
              },
              function(error) {
                vm.markingRevisionOk = false;

                flySvc.error(error);
              },
            );
          };

          vm.deleteSnapshot = function() {
            dialogsSvc
              .showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteUBOVerification')
              .then(function() {
                var id = vm.currentSnapshotDate.id;

                $http.delete(appUrls.api + '/api/ubo/DeleteSnapshot/' + id).then(
                  function({ data }) {
                    flySvc.success('msgConfirmChange');
                    vm.snapshotOverview = data;
                    vm.initializeOverview();
                  },
                  function(error) {
                    flySvc.error(error);
                  },
                );
              });
          };

          vm.snapshotDateChanged = function() {
            if (!vm.snapshot) return;

            var id = vm.currentSnapshotDate.id;

            $http.get(appUrls.api + '/api/ubo/getsnapshot/' + id).then(
              function({ data }) {
                vm.updateSnapshot(data);
                vm.documentInfo = null;

                vm.getDocumentInfo();
              },
              function(error) {
                flySvc.error(error);
              },
            );
          };

          vm.onPreviewClosed = () => {
            $timeout(function() {
              vm.showPreview = false;
              vm.activeDocumentId = null;
            }, 0);
          };

          vm.onPreviewSaved = document => {
            $timeout(function() {
              vm.showPreview = false;
              vm.activeDocument = null;
              vm.documents = vm.documents.map(x => {
                if (x.id === document.id) {
                  return {
                    ...x,
                    ...document,
                  };
                }
                return x;
              });
            }, 0);
          };

          vm.previewDocument = document => {
            vm.activeDocument = document;
            vm.showPreview = true;
          };
          vm.downloadAttachment = attachment => DocumentService.download(attachment.id);

          vm.uploadDocument = function(files) {
            if (!files || files.length < 1) return;

            var data = new FormData();
            data.append('data', files[0].data);

            vm.uploadingDocument = true;
            $http({
              method: 'post',
              url: appUrls.api + '/api/ubo/UploadUboDocument/' + vm.snapshot.id,
              headers: {
                'Content-Type': undefined,
              },
              data: data,
            })
              .then(function(response) {
                var result = response.data;
                if (!result) return;

                vm.updateSnapshot(result);
                flySvc.success();

                $http.get(appUrls.documents + '/api/documents/info/' + vm.snapshot.documentId).then(
                  function({ data }) {
                    vm.documentInfo = data;
                    vm.documents.push(data);
                    vm.uploadingDocument = false;
                    if (vm.snapshotOverview.uboResponsibilityType !== 2) {
                      vm.markSnapshotEnteredOnline();
                    }
                  },
                  function(error) {
                    vm.uploadingDocument = false;
                  },
                );
              })
              .catch(function(error) {
                vm.uploadingDocument = false;
                flySvc.error(error.code, error.parameters);
              });
          };
        },
      ],
    };
  },
]);
